module.exports = __webpack_public_path__ + "img/Uneven Spacing.6f378830.png";